import React, { Component } from 'react';

import analyticService from '../../../services/analytics';

class TrendFilter extends Component {
  constructor(props) {
    super(props);

    this.AnalyticService = analyticService;

    this.state = {
      searchTerm: this.props.searchTerm,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchTerm !== this.props.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm });
    }
  }

  onClick() {
    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Click', 'Search Bar');
  }

  handleSubmit(event) {
    event.preventDefault();

    const search = this.state.searchTerm ? this.state.searchTerm.trim() : null;
    this.AnalyticService.trackEvent(this.props.eventPrefix, 'Execute', `Search Bar ${search}`);
    this.props.updateSearch(search);
  }

  render() {
    return (
      <form
        className={`insights-search ${this.props.scrollable ? 'fixed' : ''}`}
        onSubmit={event => this.handleSubmit(event)}
      >
        <button className="search-icon"></button>
        <input
          type="text"
          placeholder={`Search ${
            this.props.insightsType === 'product-research' ? 'for a product' : ''
          }`}
          value={this.state.searchTerm || ''}
          onClick={this.onClick.bind(this)}
          onChange={event => this.setState({ searchTerm: event.target.value })}
        />
      </form>
    );
  }
}

export default TrendFilter;
